/* eslint-disable @typescript-eslint/no-magic-numbers */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ProgressCircle", {
    enumerable: true,
    get: function() {
        return ProgressCircle;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _useSize = require("../../util/useSize");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const offset = 187;
const ProgressCircle = (param)=>{
    let { className = "", style, ...props } = param;
    const size = (0, _useSize.useSize)(props.size);
    var _props_mode;
    return /*#__PURE__*/ _react.default.createElement("span", {
        style: style,
        className: _style.default.dynamic([
            [
                "e96209b0d1b7b847",
                [
                    offset,
                    props.mode === "determinate" ? (1 - props.progress / 100) * offset : 0.3 * offset,
                    offset,
                    offset / 4,
                    offset
                ]
            ]
        ]) + " " + (className || "")
    }, /*#__PURE__*/ _react.default.createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 66 66",
        className: _style.default.dynamic([
            [
                "e96209b0d1b7b847",
                [
                    offset,
                    props.mode === "determinate" ? (1 - props.progress / 100) * offset : 0.3 * offset,
                    offset,
                    offset / 4,
                    offset
                ]
            ]
        ]) + " " + "progress-circle progress-".concat((_props_mode = props.mode) !== null && _props_mode !== void 0 ? _props_mode : "indeterminate")
    }, /*#__PURE__*/ _react.default.createElement("circle", {
        cx: "33",
        cy: "33",
        r: "30",
        fill: "none",
        strokeWidth: "6",
        strokeMiterlimit: "10",
        strokeLinecap: "square",
        stroke: "currentColor",
        className: _style.default.dynamic([
            [
                "e96209b0d1b7b847",
                [
                    offset,
                    props.mode === "determinate" ? (1 - props.progress / 100) * offset : 0.3 * offset,
                    offset,
                    offset / 4,
                    offset
                ]
            ]
        ])
    })), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "e96209b0d1b7b847",
        dynamic: [
            offset,
            props.mode === "determinate" ? (1 - props.progress / 100) * offset : 0.3 * offset,
            offset,
            offset / 4,
            offset
        ]
    }, "circle.__jsx-style-dynamic-selector{stroke-dasharray:".concat(offset, "px;stroke-dashoffset:").concat(props.mode === "determinate" ? (1 - props.progress / 100) * offset : 0.3 * offset, "px;-webkit-transform-origin:center;-moz-transform-origin:center;-ms-transform-origin:center;-o-transform-origin:center;transform-origin:center}.progress-indeterminate.__jsx-style-dynamic-selector{-webkit-animation:rotate 1.5s linear infinite;-moz-animation:rotate 1.5s linear infinite;-o-animation:rotate 1.5s linear infinite;animation:rotate 1.5s linear infinite}.progress-indeterminate.__jsx-style-dynamic-selector circle.__jsx-style-dynamic-selector{-webkit-animation:dash 1.5s ease-in-out infinite;-moz-animation:dash 1.5s ease-in-out infinite;-o-animation:dash 1.5s ease-in-out infinite;animation:dash 1.5s ease-in-out infinite}.progress-determinate.__jsx-style-dynamic-selector circle.__jsx-style-dynamic-selector{-webkit-transition:stroke-dashoffset 350ms;-moz-transition:stroke-dashoffset 350ms;-o-transition:stroke-dashoffset 350ms;transition:stroke-dashoffset 350ms}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes rotate{0%{-moz-transform:rotate(0deg);transform:rotate(0deg)}100%{-moz-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes rotate{0%{-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-o-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes rotate{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes dash{0%{stroke-dashoffset:").concat(offset, "px}50%{stroke-dashoffset:").concat(offset / 4, "px;-webkit-transform:rotate(135deg);transform:rotate(135deg)}100%{stroke-dashoffset:").concat(offset, "px;-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes dash{0%{stroke-dashoffset:").concat(offset, "px}50%{stroke-dashoffset:").concat(offset / 4, "px;-moz-transform:rotate(135deg);transform:rotate(135deg)}100%{stroke-dashoffset:").concat(offset, "px;-moz-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes dash{0%{stroke-dashoffset:").concat(offset, "px}50%{stroke-dashoffset:").concat(offset / 4, "px;-o-transform:rotate(135deg);transform:rotate(135deg)}100%{stroke-dashoffset:").concat(offset, "px;-o-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes dash{0%{stroke-dashoffset:").concat(offset, "px}50%{stroke-dashoffset:").concat(offset / 4, "px;-webkit-transform:rotate(135deg);-moz-transform:rotate(135deg);-o-transform:rotate(135deg);transform:rotate(135deg)}100%{stroke-dashoffset:").concat(offset, "px;-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}")));
};

//# sourceMappingURL=ProgressCircle.js.map